import React from "react";
import "../styles.css";

function Loading() {
    return (
        <>
           
           <div className="loading">
            <h1>
                LOADING
            </h1>
            </div>
            </>
    )
}


export default Loading;